import { __assign, __extends } from "tslib";
import React from 'react';
import memoizeOne from 'memoize-one';
import shallowEqual from 'shallowequal';
import { SplitContext } from './SplitContext';
import { getControlTreatmentsWithConfig, WARN_ST_NO_CLIENT } from './constants';
function argsAreEqual(newArgs, lastArgs) {
    return newArgs[0] === lastArgs[0] && // client
        newArgs[1] === lastArgs[1] && // lastUpdate
        shallowEqual(newArgs[2], lastArgs[2]) && // names
        shallowEqual(newArgs[3], lastArgs[3]) && // attributes
        shallowEqual(newArgs[4], lastArgs[4]); // client attributes
}
function evaluateFeatureFlags(client, lastUpdate, names, attributes, _clientAttributes) {
    return client.getTreatmentsWithConfig(names, attributes);
}
/**
 * SplitTreatments accepts a list of feature flag names and optional attributes. It access the client at SplitContext to
 * call 'client.getTreatmentsWithConfig()' method, and passes the returned treatments to a child as a function.
 *
 * @see {@link https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#get-treatments-with-configurations}
 */
var SplitTreatments = /** @class */ (function (_super) {
    __extends(SplitTreatments, _super);
    function SplitTreatments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Attaching a memoized `client.getTreatmentsWithConfig` function to the component instance, to avoid duplicated impressions because
        // the function result is the same given the same `client` instance, `lastUpdate` timestamp, and list of feature flag `names` and `attributes`.
        _this.evaluateFeatureFlags = memoizeOne(evaluateFeatureFlags, argsAreEqual);
        return _this;
    }
    SplitTreatments.prototype.render = function () {
        var _this = this;
        var _a = this.props, names = _a.names, children = _a.children, attributes = _a.attributes;
        return (React.createElement(SplitContext.Consumer, null, function (splitContext) {
            var client = splitContext.client, isReady = splitContext.isReady, isReadyFromCache = splitContext.isReadyFromCache, isDestroyed = splitContext.isDestroyed, lastUpdate = splitContext.lastUpdate;
            var treatments;
            var isOperational = !isDestroyed && (isReady || isReadyFromCache);
            if (client && isOperational) {
                // Cloning `client.getAttributes` result for memoization, because it returns the same reference unless `client.clearAttributes` is called.
                // Caveat: same issue happens with `names` and `attributes` props if the user follows the bad practice of mutating the object instead of providing a new one.
                treatments = _this.evaluateFeatureFlags(client, lastUpdate, names, attributes, __assign({}, client.getAttributes()));
            }
            else {
                treatments = getControlTreatmentsWithConfig(names);
                if (!client) {
                    _this.logWarning = true;
                }
            }
            // SplitTreatments only accepts a function as a child, not a React Element (JSX)
            return children(__assign(__assign({}, splitContext), { treatments: treatments }));
        }));
    };
    SplitTreatments.prototype.componentDidMount = function () {
        if (this.logWarning) {
            console.log(WARN_ST_NO_CLIENT);
        }
    };
    return SplitTreatments;
}(React.Component));
export { SplitTreatments };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/SplitTreatments.js
// module id = 2004
// module chunks = 25